import { Modal } from "antd";
import { ReactComponent as Close } from '../../../../../../assets/images/icon/close.svg';
import TicketCheckCarousel from "./ticketCheckCarousel";
import { useMyContext } from "../../../../../../entities/context";

interface IProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    programBookingId: number
    imageUrl: string
}

const ProgramBookingTicketCheckModal = ({ open, setOpen, programBookingId, imageUrl }: IProps) => {
    const { topHeight } = useMyContext();

    return <>
        <Modal style={{ margin: 0, top: 0, padding: 0, overflow: 'hidden', maxWidth: '100vw' }} styles={{ mask: { marginInline: 'auto', left: '-100vw', top: '-100vh', width: '300vw', height: '300vh', backgroundImage: `url(${imageUrl})`, backgroundPosition: 'center', backgroundSize: 'cover' }, content: { boxShadow: 'none', top: 0, left: 0, maxWidth: '480px', margin: 0, padding: 0, borderRadius: 0, backgroundColor: 'transparent' }, wrapper: { background: 'var(--dimd100, rgba(0,0,0,0.45)', backdropFilter: 'blur(30px)' } }} open={open} footer={null} closeIcon={false}>
            <div style={{ marginBottom: '26px', }}>
                <div style={{ position: 'fixed', top: Number(topHeight), height: '48px' }}>
                    <Close width={24} height={24} stroke="#FFFFFF" style={{ padding: 'var(--space12)', cursor: 'pointer', marginLeft: '16px' }} onClick={() => setOpen(false)} />
                </div>
                <div style={{ marginTop: 116 + Number(topHeight) }}>
                    <TicketCheckCarousel programBookingId={programBookingId} />
                </div>
            </div>
            <div className="body/b2 base/white" style={{ textAlign: 'center' }}>
                입구에서 QR코드를 보여주세요
            </div>
        </Modal>
    </>
}

export default ProgramBookingTicketCheckModal;